export default {
    disableToggle(ref, disabled){
        let btnRequest = $(ref)
        if(disabled){
            btnRequest.attr('disabled', true)
            btnRequest.text('Salvando...')
        } else {
            btnRequest.attr('disabled', false)
            btnRequest.text('Salvar')
        }
    },
}